import { RegionService } from '../../core/services/region.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Region } from '../../core/models/classes/region';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { ActivatedRoute } from '@angular/router';
import { Fill, Stroke, Style } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import * as proj4x from 'proj4/dist/proj4';
const proj4 = (proj4x as any).default;
import { register } from 'ol/proj/proj4';
import { buffer } from 'ol/extent';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { User } from '../../core/models/classes/user';
import { UserService } from '../../core/services/user.service';
import { Observable } from 'rxjs';
import { RegionReference } from '../../core/models/classes/region-reference';
import { RegionMetaDataModel } from '../../core/models/classes/region-metadata';
import WKT from 'ol/format/WKT';
import { DataService } from '../../core/services/data.service';
import { SettingModel } from '../../core/models/classes/setting';
import { SettingsService } from '../../core/services/settings.service';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Role } from '../../core/models/enums/user-role';
import { MatSort } from '@angular/material/sort';
import { Cache } from '../../core/models/classes/cache';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PeriodicCacheModel } from '../../core/models/classes/periodic-cache';
import { MatDialog } from '@angular/material/dialog';
import { SignalrService } from '../../core/services/signalr.service';
import { HttpClient } from '@angular/common/http';
import { NotificationModel } from '../../core/models/classes/notification';
import {
  CachingLevel,
  CachingLevelen,
} from '../../core/models/classes/caching-level';
import { MatRadioChange } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatavalidityComponent } from '../datavalidity/datavalidity.component';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss'],
})
export class RegionComponent implements OnInit, OnDestroy {
  pageTitle: string;
  errorMessage: string;
  selectedRegion: Region;
  polyone: any;
  selectedRegionMetaData: RegionMetaDataModel;
  regionReference: RegionReference;
  regRef: Observable<RegionReference[]>;
  map: any;
  vectorLayer: any;
  p1: any;
  p2: any;
  p3: any;
  p4: any;
  p5: any;
  coords: any;
  area: any;
  users: Observable<User[]>;
  allUser: User[];
  sUsers: User[];
  selectedUser: User;
  regions: RegionReference[];
  sRegions: RegionReference[];
  swkt: string;
  appSetting: SettingModel;
  userDataSource;
  userDataSourceOrg;
  cacheStatus: Cache;
  isCacheDisabled: boolean;
  isReCacheDisabled: boolean;
  isChecked: boolean;
  hideWeekDays: boolean = true;
  hideDayTime: boolean = false;
  statusText: string;
  selectionModel = new SelectionModel<User>(true, []);
  displayedUserColumns: string[] = ['select', 'name', 'role', 'domain'];
  @ViewChild(MatSort) sort: MatSort;
  percentage: number = 0;
  precentageText: string;
  cacheTime: string = '';
  cacheDay: string = '';
  cacheFrequency: string = '';
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  startTime: string = $localize`Start Time`;
  public modelData: NotificationModel;
  schemaStatus: number;
  showCs: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private regionService: RegionService,
    private dataService: DataService,
    private settingService: SettingsService,
    private dialog: MatDialog,
    private signalRService: SignalrService,
    private http: HttpClient,
    private _snackBar: MatSnackBar
  ) {
    this.selectedRegion = new Region();
    this.selectedRegionMetaData = new RegionMetaDataModel();
    this.regionReference = new RegionReference();
    this.pageTitle = '';
    this.vectorLayer = new VectorLayer();
    this.allUser = [];
    this.loadAssigneduserInfo();
    this.appSetting = new SettingModel();
  }

  ngOnInit(): void {


    this.loadSettings();
    this.users = this.userService.users;
    this.userService.getUsers();
    this.fetchUsers();
    this.getStatus(); //Enable/disable cache and recache buttons. Show status text
    this.getStatusOfPart1Job(); //Get status of Part 1 Refresh job
    //  this.signalRService.onReceiveUpdate((data) =>{
    //               console.log(data);
    //         });
    //this.startHttpRequest();
  }

  fetchUsers() {
    this.users.subscribe((data) => {
      this.sUsers = data;
      this.sUsers.forEach((element) => {
        element.role = Role[element.roleId];
        element.domain = element.cSID === 0 ? 'AdminPortal' : 'cableScout';
      });
      this.userDataSource = new MatTableDataSource<User>(this.sUsers);
      this.userDataSourceOrg = new MatTableDataSource<User>(this.sUsers);
      this.userDataSource.sort = this.sort;
    });
  }

  private startHttpRequest = () => {
    this.http.get(`${environment.ipServer}/notify`).subscribe({
      next: (res) => {},
      error: (err) => {},
    });
  };

  async ngOnDestroy() {
    await this.signalRService.unSubscribeToRegion(this.selectedRegionMetaData.name.trimEnd().toUpperCase());
    //await this.signalRService.closeConnection();
  }

  applyFilter(event: Event) {
    this.userDataSource = this.userDataSourceOrg;
    this.userDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    if (this.userDataSource.filter === '') {
      this.userDataSource = this.userDataSourceOrg;
    } else {
      var filteredList = new MatTableDataSource<User>(
        this.userDataSource.filteredData.filter(
          (x) =>
            x.name.includes(this.userDataSource.filter) ||
            x.role.toLowerCase().includes(this.userDataSource.filter)
        )
      );
      this.userDataSource = filteredList;
    }
  }

  isAllSelected() {
    const numSelected = this.selectionModel.selected.length;
    const numRows = this.userDataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selectionModel.clear();
      return;
    }
    this.selectionModel.select(...this.userDataSource.data);
  }

  checkboxLabel(row?: User): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${
      this.selectionModel.isSelected(row) ? 'deselect' : 'select'
    } row ${row.id + 1}`;
  }

  loadSettings() {
    this.settingService.getSettings().subscribe({
      next: (s) => {
        this.appSetting = s; //Object.values(s)[0];
        if (this.appSetting !== undefined) {
          this.defineProjection();
          this.loadMap();
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  defineProjection(): void {
    try {
      proj4.defs([
        [`EPSG:${this.appSetting.srid}`, environment[this.appSetting.srid]],
        [
          'EPSG:3857',
          '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs//',
        ],
      ]);
      register(proj4);
    } catch {
      throw Error(
        $localize`SRID or Projection for the specified SRID is missing`
      );
    }
  }

  loadMap(): void {
    try {
      this.map = new Map({
        target: 'map',
        layers: [
          new TileLayer({
            source: new XYZ({
              url: this.appSetting.wmsLink,
              projection: 'EPSG:3857',
              attributions: this.appSetting.mapAttributation,
            }),
          }),
        ],
        view: new View({
          zoom: 7,
          projection: 'EPSG:3857',
        }),
      });
    } catch (e: unknown) {
      console.log(e);
    }
  }

  loadAssigneduserInfo() {
    const id = +this.route.snapshot.paramMap.get('id');
    this.getRegionMeta(id);
  }

  getPolygon(id: number): void {
    try {
      if (this.appSetting !== undefined) {
        const format = new WKT();

        // const wkt = `${Object.values(this.selectedRegionMetaData)[4]}`;
        const wkt = `${this.selectedRegionMetaData.wkt}`;
        const feature = format.readFeature(wkt, {
          dataProjection: `EPSG:${this.appSetting.srid}`,
          featureProjection: 'EPSG:3857',
        });

        const vectorSource = new VectorSource({
          features: [feature],
        });

        feature.setStyle(
          new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.6)',
            }),
            stroke: new Stroke({
              color: 'red',
              width: 3,
            }),
          })
        );

        this.vectorLayer = new VectorLayer({
          source: vectorSource,
        });
        if (this.map !== undefined) {
          this.map.addLayer(this.vectorLayer);
          const extent = vectorSource.getExtent();
          buffer(extent, 1);
          this.map.getView().fit(extent, this.map.getSize());
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  getAssignedUser(id: number): void {
    this.regRef = this.regionService.userRef;
    this.regionService.getUsers(+id).subscribe({
      next: (data) => {
        this.regions = data;
        this.sRegions = this.regions;
        this.addUserToRegion();
      },
      error: (err) => {},
    });
  }

  getRegionMeta(id: number): void {
    this.regionService.getRegionMetaData(id).subscribe({
      next: (data) => {
        this.selectedRegionMetaData = data;
        this.getStatus();
        this.getPeriodicStatus();
        this.getPolygon(id);
        this.getAssignedUser(id);
        //region notification
        this.signalRService.startConnection(this.selectedRegionMetaData.name);
        // console.log(this.selectedRegionMetaData.name);
        //this.signalRService.subscribeToRegion(this.selectedRegionMetaData.name);
        this.getNotification();
        // this.signalRService.onReceiveUpdate((data) => {
        //   console.log(data);
        // });
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  addUserToRegion(): void {
    this.regions.forEach((element) => {
      let user = this.sUsers.find((x) => x.id === element.userID);
      if (user !== undefined) {
        this.selectionModel.select(user);
      }
    });
  }

  add(row: User, value: MatCheckboxChange) {
    if (value.checked === true) {
      this.addSelectedUser(row);
    } else {
      var reference = this.regions.find(
        (x) =>
          x.regionID === this.selectedRegionMetaData.regionID &&
          x.userID === row.id
      );

      if (reference !== undefined) {
        this.regionService.removeUserFromRegion(reference.id).subscribe({
          next: (data) => {
            //this.regions = this.regions.filter(item => item.id !== reference.id);
          },
        });
      }
    }
  }

  addSelectedUser(row: User) {
    if (this.selectionModel.selected.find((x) => x.id === row.id)) {
      this.regionReference.regionID = this.selectedRegionMetaData.regionID;
      this.regionReference.userID = row.id; //cSID
      this.regionService.addUserToRegion(this.regionReference);
      this.regionService
        .getUsers(this.selectedRegionMetaData.regionID)
        .subscribe({
          next: (data) => {
            this.regions = data;
          },
        });
    }
  }

  remove(user: User): void {
    const idx = this.allUser.indexOf(user);
    if (idx !== -1) {
      this.allUser.splice(idx, 1);
      for (let i = 0; i < Object.keys(this.regions).length; i++) {
        //user.cSID
        if (
          this.sRegions[i].userID === user.id &&
          this.sRegions[i].regionID === this.selectedRegionMetaData.regionID
        ) {
          const reg = this.sRegions[i];

          if (reg !== undefined) {
            this.regionService.removeUserFromRegion(reg.id);
          }
        }
      }
    }
  }

  startCache(): void {
    if (
      this.selectedRegionMetaData.name !== undefined &&
      this.selectedRegionMetaData.name !== '' &&
      this.selectedRegionMetaData.name !== null
    ) {
      this.dataService
        .startCaching(this.selectedRegionMetaData.regionNameID)
        .subscribe({
          next: (data) => {
            // this.getNotification();
            this.statusText = $localize`Caching in progress since `;
            this.percentage = 0;
            this.precentageText = '0';
          },
        });

      this.isCacheDisabled = true;
    }
  }

  startReCache(): void {
    if (
      this.selectedRegionMetaData.name !== undefined &&
      this.selectedRegionMetaData.name !== '' &&
      this.selectedRegionMetaData.name !== null
    ) {
      this.dataService
        .startReCaching(this.selectedRegionMetaData.regionNameID)
        .subscribe({
          next: (data) => {},
          error: (err) => {},
        });
      this.isCacheDisabled = false;
    }

    this.cacheDay = '';
    this.cacheTime = '';
    this.cacheFrequency = null;
    this.hideDayTime = false;
    this.saveCacheSettings();
  }

  getStatus() {
    if (this.selectedRegionMetaData.name !== undefined) {
      this.dataService.getRefreshStatus().subscribe({
        next: (p) => {
          this.schemaStatus = p;
          if (this.schemaStatus === 0) {
            //State - In Progress
            this.isCacheDisabled = true;
            this.isReCacheDisabled = true;
            this.statusText = $localize`Refreshing data in progress`;
          } else if (this.schemaStatus === 1) {
            //State - Failed
            this.statusText = $localize`Error occured while refreshing schema. Check the refresh logs.`;
            this.isCacheDisabled = true;
            this.isReCacheDisabled = true;
          } else {
            this.isCacheDisabled = false;
            this.isReCacheDisabled = false;
            this.fetchStatus();
          }
        },
      });
    }
  }

  fetchStatus() {
    this.dataService.getStatus(this.selectedRegionMetaData.name).subscribe({
      next: (data) => {
        this.cacheStatus = data;
        if (data !== null) {
          if (this.cacheStatus.status === 'Caching') {
            this.isCacheDisabled = true;
            this.statusText =
              $localize`Caching in progress since ` +
              ` ${Object.values(this.cacheStatus)[3]} `;
          } else if (this.cacheStatus.status === 'completed') {
            this.isCacheDisabled = false;
            this.statusText =
              $localize`Caching ended since ` +
              ` ${Object.values(this.cacheStatus)[3]} `;
          } else {
            this.cachingInQueue();
          }
        } else {
          this.cachingInQueue();
        }
      },
    });
  }

  cachingInQueue() {
    this.dataService
      .getRegionStatus(this.selectedRegionMetaData.name)
      .subscribe({
        next: (data) => {
          this.isCacheDisabled = data;
          if (this.isCacheDisabled === true) {
            this.statusText = $localize`Queued for Caching`;
          }
        },
      });
  }

  getStatusOfPart1Job() {
    this.dataService.getRefreshStatus().subscribe({
      next: (p) => {
        this.schemaStatus = p;
        if (this.schemaStatus === 0) {
          //State - In Progress
          this.isCacheDisabled = true;
          this.isReCacheDisabled = true;
          this.statusText = $localize`Refreshing data in progress`;
        } else if (this.schemaStatus === 1) {
          //State - Failed
          this.statusText = $localize`Error occured while refreshing schema. Check the refresh logs.`;
          this.isCacheDisabled = true;
          this.isReCacheDisabled = true;
        } //State - Completed with Warnings
        else {
          this.isCacheDisabled = false;
          this.isReCacheDisabled = false;
        }
      },
    });
  }

  getNotification() {
    try {
      this.signalRService.hubConnection.on(
        'ReceiveUpdate',
        (data: NotificationModel) => {
          this.modelData = data;
          if (
            this.modelData !== undefined &&
            this.modelData.region === this.selectedRegionMetaData.name.trimEnd()
          ) {
            if (this.modelData.currentStep === 22) {
              this.getStatus();
              this.percentage =
                (this.modelData.currentStep / this.modelData.totalStep) * 100;
              this.precentageText = `${this.modelData.currentStep}/${this.modelData.totalStep}`;
            } else if (this.modelData.currentStep > 0) {
              if ($localize.locale === 'de') {
                this.statusText =
                  CachingLevel[this.modelData.currentStep] +
                  ' ' +
                  $localize`cached`;
              } else {
                this.statusText =
                  CachingLevelen[this.modelData.currentStep] +
                  ' ' +
                  $localize`cached`;
              }
              this.percentage =
                (this.modelData.currentStep / this.modelData.totalStep) * 100;
              this.precentageText = `${this.modelData.currentStep}/${this.modelData.totalStep}`;
            } else {
            }
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  getPeriodicStatus() {
    if (this.selectedRegionMetaData.name !== undefined) {
      this.regionService
        .getPeriodicTask(this.selectedRegionMetaData.name)
        .subscribe({
          next: (data) => {
            if (data !== undefined && data !== null) {
              if (data.day === 'Daily' && data.isActive === true) {
                //Daily
                this.cacheFrequency = '3';
              } else if (data.isActive === true) {
                //Weekly
                this.cacheFrequency = '2';
              } //One-time
              else {
                this.cacheFrequency = '1';
              }
              this.cacheTime = data.time;
              this.cacheDay = data.day;
              this.hideDayTime = true;
              this.hideWeekDays = this.cacheFrequency === '3' ? false : true;
            } //when caching period was not set and spontaneous Cache was performed
            else {
            }
          },
          error: (err) => {},
        });
    }
  }

  radioChange(event: MatRadioChange) {
    this.cacheTime = '';
    this.cacheDay = '';
    this.hideDayTime = true;
    this.hideWeekDays = this.cacheFrequency === '3' ? false : true;
    this.saveCacheSettings();
  }

  applyChanges(e) {
    if (this.cacheDay != '' && this.cacheTime != '') {
      this.saveCacheSettings();
    } else if (this.cacheDay != '') {
      this._snackBar.open($localize`Cache time not set`, '', {
        duration: 1000,
      });
    } else {
      this._snackBar.open($localize`Cache day not set`, '', {
        duration: 1000,
      });
    }
  }

  setDataValidity(): void {
    const regid = +this.route.snapshot.paramMap.get('id');
    this.dialog.open(DatavalidityComponent, {
      data: regid,
      panelClass: 'custom-dialog-container',
    });
  }

  saveCacheSettings() {
    let cache = new PeriodicCacheModel();
    if (this.cacheFrequency === '3') {
      this.cacheDay = 'Daily';
    }
    cache.day = this.cacheDay;
    cache.time = this.cacheTime;
    cache.regionName = this.selectedRegionMetaData.name;
    cache.isActive = this.cacheFrequency === '1' ? false : true;
    if (this.cacheDay !== '' && this.cacheTime !== '') {
      this.regionService.addPeriodicTask(cache).subscribe({
        next: (data) => {},
      });
    } else if (this.cacheDay !== '') {
      this._snackBar.open($localize`Cache time not set`, '', {
        duration: 1000,
      });
    } else {
      this._snackBar.open($localize`Cache day not set`, '', {
        duration: 1000,
      });
    }
  }

  setDisplayPermissions() {
    this.showCs = !this.showCs;

    if (this.showCs) {
      this.userDataSource = this.sUsers;
    } else {
      this.userDataSource = this.sUsers.filter(
        (x) => x.domain === 'AdminPortal'
      );
    }
  }
}
